import { useCallback } from 'react';
import styled from 'styled-components';
import { AppAudioPlayerControlsList } from '@elfsight/icons';
import { getColorWithAlpha } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { useTheme } from '../../../common';
import { usePlayer } from '../../PlayerProvider';
import { DefaultButton, type DefaultButtonProps } from './DefaultButton';
import { Icon } from './Icon';

export function PlaylistButton({
  className,
  withoutMargin = false,
  ...forwardingProps
}: DefaultButtonProps) {
  const { showPlaylist, setShowPlaylist } = usePlayer();
  const { textColor } = useTheme();
  const { messagePlaylist } = useSettings();

  const onClick = useCallback(() => {
    setShowPlaylist(!showPlaylist);
  }, [setShowPlaylist, showPlaylist]);

  return (
    <PlaylistButtonComponent
      {...forwardingProps}
      className={className}
      onClick={onClick}
      title={messagePlaylist}
      withoutMargin={withoutMargin}
    >
      <Icon
        as={AppAudioPlayerControlsList}
        fill={getColorWithAlpha(textColor, 1)}
      />
    </PlaylistButtonComponent>
  );
}

export const PlaylistButtonComponent = styled(DefaultButton)``;
